import BlogHeader from './blog'
import StandardHeader from './standard'

export default {
  none: null,
  standard: StandardHeader,
  blog: BlogHeader,
}
